/**
 * Register the Duro primitive renderers into the editor's catalog via the
 * injection seam, so the canvas renders real themed Duro for
 * button/heading/card/input/icon.
 * Idempotent; call once at app startup (before the editor first renders).
 */
import { registerWidget } from "@website-builder/editor";
import {
  DuroButtonWidget,
  DuroHeadingWidget,
  DuroCardWidget,
  DuroInputWidget,
} from "./duroWidgets.js";
import { DuroIconWidget } from "./duroDsWidgets.js";
import { withSiteDesignSystem } from "./canvasDesignSystem.js";

let registered = false;

export function registerDuroPrimitives(): void {
  if (registered) return;
  registered = true;
  // Duro unless the site has an uploaded design system (then the sandbox's
  // markup, in a shadow root per widget — see canvasDesignSystem).
  registerWidget("button", withSiteDesignSystem("button", DuroButtonWidget));
  registerWidget("heading", withSiteDesignSystem("heading", DuroHeadingWidget));
  registerWidget("card", withSiteDesignSystem("card", DuroCardWidget));
  registerWidget("input", withSiteDesignSystem("input", DuroInputWidget));
  registerWidget("icon", withSiteDesignSystem("icon", DuroIconWidget));
}
